import CustomInput from "@/components/shared/CustomInput";
import CustomSelect from "@/components/shared/CustomSelect";
import CustomTimePicker from "@/components/shared/CustomTimePicker";
import DashboardConstants from "@/store/constants/dashboardRecords";
import DashboardInternalData from "@/internalData/Dashboard";
import TrashIcon from "@/components/shared/TrashIcon"
import GlobalConstants from "@/store/constants/global"

export default {
  name: "CarryingIORecordsTable",
  components: {
    CustomInput,
    CustomSelect,
    CustomTimePicker,
    TrashIcon,
  },
  data() {
    return {
      carryFields: DashboardInternalData.carryingIORecords.carryFields,
      inOutFields: DashboardInternalData.carryingIORecords.inOutFields,
      estimatedTimeFields: DashboardInternalData.carryingIORecords.estimatedTimeFields,
      formatTable: `cus-border-x-table-default mt-1 cus-bg-header cus-cell-last-child-none
       cus-padding-table-none cus-bg-table cus-font-size-main cus-cell-first-tr-last-th-none
      print-table-cell-right-none cus-page-break html2canvas-page-break`
    };
  },
  methods: {
    showConfirmModal(orderId) {
      this.$bvModal.show('confirm-modal');
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: "carryingIO", orderId: orderId });
    },
    resetEstimateSpecifiedTime(index) {
      let path = ["carryingIO", index, "estimatedTime.specifiedTime"].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: path, value: "" });
    },
    setInputCarryingIO(attr, value, index) {
      if (attr == "estimatedTime.type" && value != null) {
        this.resetEstimateSpecifiedTime(index);
      }
      let path = ["carryingIO", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: path, value: value });

      //recalculate revision
      if (["inOut", "estimatedTime.type"].includes(attr)) {
        this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
      }
    },
    addNewCarryingIO() {
      this.$store.commit(DashboardConstants.COMMIT.addNewRecord, "carryingIO");
    },
    handleFocusLine(subAttr, index, status) {
      //handle lost focus
      let obj = { attr: "carryingIO", index: index, subAttr: subAttr, status: status };
      this.$store.commit(DashboardConstants.COMMIT.changeStatusFocus, obj);
      if (!status) {
        //recalculate revision
        this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
      }
    },
  },
  computed: {
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    diaryPrevious() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].carryingIO;
    }
  }
};